export enum ProductDevelopmentStatus {
  Draft = 0,
  InDevelopment = 1,
  UnderReview = 2,
  Approved = 3,
  ReadyForProduction = 4,
  Inactive = 98,
  Rejected = 99,
}
